import { createTheme } from '@mui/material/styles';

export default createTheme({
  palette: {
    primary: {
      main: '#2b485c',
      light: '#577389',
      dark: '#002132',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#2194f3',
      light: '#ff7961',
      dark: '#ba000d',
      contrastText: '#000000',
    },
  },
});
